import React from 'react'
import AppFrame from '../AppFrame'
import { useQuery } from "@apollo/client"
import { get, map } from 'lodash'

import PageHeader from '../components/PageHeader'
import { QUERY_PAY_BILL_DATA } from '../data/services/graphqlQueries'
import ClinicCard from '../components/ClinicCard'

export default({globalData}) => {
  const { loading, error, data } = useQuery(QUERY_PAY_BILL_DATA, {
    notifyOnNetworkStatusChange: true
  })

  if (loading) return null
 
  const _pageData = get(data, 'pageData[0]')

  const cardCallback = (c) => {
    window.open(c.payUrl, '_blank');
  }

  return (
    <AppFrame data={globalData}>
      <div className="max-w-6xl mx-auto px-4 pt-12">
        <PageHeader title={_pageData.title} />
        <div dangerouslySetInnerHTML={{__html: _pageData ? _pageData.body : ''}} className="mt-12 mb-8"></div>
      </div>
      <div className="max-w-6xl mx-auto px-4 pb-8 pt-12 min-h-[400px]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {
            map(globalData.clinics, (c, index) => {
              return <ClinicCard 
                globalData={globalData} 
                clinic={c}
                key={`appointment-card-${index}`} 
                callback={cardCallback}
                cta="pay bill"
              />
            })
          }
        </div>
       </div>
    </AppFrame>
  )
}